import { useCallback, useEffect } from 'react';

import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';
import { useOrganizationProperties } from '@/modules/transaction/hooks';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

const useSetPaymentMethods = () => {
  const { employee } = useEmployeeStore();
  const { checkIsAvailablePaymentMethod, organizationProperties } = useOrganizationProperties();

  const handleSetPaymentMethods = useStore((state) => state.handleSetPaymentMethods);
  const handleSetActivePaymentMethod = useStore((state) => state.handleSetActivePaymentMethod);

  const selectedPaymentMethod = useStore((state) => state.selectedMethod);
  const isPaymentMethodAvailable = checkIsAvailablePaymentMethod(selectedPaymentMethod);

  const handleGettingPaymentMethods = useCallback((paymentMethods: PaymentMethod[]) => {
    const updatedPaymentMethods = paymentMethods
      ?.filter((method) => method?.paymentMethodOwner?.employeeId === employee?.id)
      ?.map((method) => ({
        ...method,
        ...method?.id === selectedPaymentMethod?.id ? { isChecked: true } : {},
      }));
    handleSetPaymentMethods(updatedPaymentMethods);
  }, [employee?.id, handleSetPaymentMethods, selectedPaymentMethod]);

  useEffect(() => {
    if (isPaymentMethodAvailable) handleSetActivePaymentMethod();
  }, [handleSetActivePaymentMethod, isPaymentMethodAvailable]);

  return {
    organizationProperties,
    handleGettingPaymentMethods,
  };
};

export default useSetPaymentMethods;
